import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private endpointPrefix = '';
  private microfrontend = false;

  setEndpointPrefix(endpointPrefix: string): void {
    this.endpointPrefix = endpointPrefix;
  }


  getEndpointFor(api: string): string {
    return `${this.endpointPrefix}${api}`;
  }

  getOscatEndpoint(baseUrl: string ,api: string): string {
    return `${baseUrl}${api}`;
  }
}
